const hotRank = [
  { tag: "实锤", title: "主播 贾大嘴 助农佣金四六分成" },
  { tag: "实锤", title: "顶流 顾言 机场冷脸甩手" },
  { tag: "追更", title: "导演 程墨 考古言论再翻车" },
  { tag: "追更", title: "组合 池野 与经纪人越界画面" },
];

const quickCards = [
  { icon: "ri-fire-line", num: "03", label: "今日塌房", unit: "位" },
  { icon: "ri-team-line", num: "420w+", label: "累计围观", unit: "次" },
  { icon: "ri-download-2-line", num: "1.8w", label: "脱粉实况", unit: "条" },
  { icon: "ri-shield-check-line", num: "24h", label: "证据核对", unit: "内" },
];

export default function Hero() {
  return (
    <section id="scene" className="mx-auto w-full max-w-7xl px-4 pt-5 pb-10 md:px-6 md:pt-8 md:pb-14">
      <div className="grid gap-4 md:gap-5 lg:grid-cols-3">
        {/* 头条实锤大卡 */}
        <article className="group relative flex min-h-[420px] flex-col justify-end overflow-hidden rounded-2xl lg:col-span-2 lg:min-h-[560px]">
          <img
            src="https://readdy.ai/api/search-image?query=Moody%20editorial%20tabloid%20news%20photography%20of%20a%20dark%20stage%20backdrop%20with%20a%20silhouetted%20handheld%20phone%20and%20camera%20flash%2C%20dramatic%20deep%20red%20rim%20lighting%2C%20warm%20spotlight%20from%20above%2C%20grainy%2035mm%20film%2C%20documentary%20expos%C3%A9%20mood%2C%20high%20contrast%20shadows%2C%20cinematic%20wide%20shot&width=1280&height=840&seq=gk-hero-2026&orientation=landscape"
            alt="呱呱黑料本期头条塌房现场新闻摄影配图"
            className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/45 to-foreground-950/15"></div>
          <div className="relative flex h-full w-full flex-col justify-end gap-3 p-5 md:p-7">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                <span className="gk-pulse inline-block h-1.5 w-1.5 rounded-full bg-background-50"></span>
                实锤直击
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-foreground-950/55 px-3 py-1 text-xs font-medium text-background-100 backdrop-blur">
                <i className="ri-time-line"></i> 今日 14:20 更新
              </span>
            </div>
            <h2 className="font-display text-2xl font-black leading-snug text-background-50 md:text-4xl">
              头部主播 贾大嘴 助农返佣分成实锤
              <span className="mt-2 block text-accent-300">网友：滤镜碎得比屏幕还快</span>
            </h2>
            <p className="max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-[15px]">
              本台整理 6 段后台沟通截图与 3 份合作协议，逐条比对该主播公开承诺与真实佣金比例，塌房现场从「翻车」走向「盖棺」。
            </p>
            <div className="mt-1 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#timeline"
                className="inline-flex w-fit cursor-pointer items-center justify-center whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-300"
              >
                展开崩塌全记录
                <i className="ri-arrow-right-line ml-1.5"></i>
              </a>
              <a
                href="#reputation"
                className="inline-flex w-fit cursor-pointer items-center whitespace-nowrap text-sm font-semibold text-background-100 underline-offset-4 hover:underline"
              >
                <i className="ri-focus-3-line mr-1.5 text-accent-300"></i>
                围观脱粉现场
              </a>
            </div>
          </div>
        </article>

        {/* 右栏：热度围观榜 */}
        <aside className="flex flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 shadow-card">
          <div className="flex items-center justify-between border-b border-background-200 px-5 py-3.5">
            <h3 className="flex items-center gap-2 font-display text-base font-bold text-foreground-950">
              <i className="ri-fire-fill text-primary-500"></i>
              正在发酵
            </h3>
            <span className="text-xs text-foreground-500">热度实时刷新</span>
          </div>
          <ul className="flex flex-1 flex-col divide-y divide-background-200/70 px-5">
            {hotRank.map((item, i) => (
              <li key={item.title}>
                <a href="#archive" className="group flex cursor-pointer items-center gap-3.5 py-3.5">
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-sm font-black ${
                      i === 0
                        ? "bg-primary-500 text-background-50"
                        : i === 1
                          ? "bg-accent-500 text-foreground-950"
                          : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    {i + 1}
                  </span>
                  <span className="flex-1">
                    <span className="block truncate text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-700">
                      {item.title}
                    </span>
                    <span className="mt-0.5 block text-xs text-foreground-500">
                      {item.tag === "实锤" ? "证据已归档" : "持续跟进中"}
                    </span>
                  </span>
                  <span
                    className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-bold ${
                      item.tag === "实锤"
                        ? "bg-primary-100 text-primary-700"
                        : "bg-secondary-100 text-secondary-700"
                    }`}
                  >
                    {item.tag}
                  </span>
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#archive"
            className="mx-5 mb-4 inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-full border border-background-200 px-4 py-2 text-xs font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看完整塌房档案
            <i className="ri-arrow-right-up-line ml-1"></i>
          </a>
        </aside>
      </div>

      {/* 底部快速连播卡 */}
      <div className="mt-4 grid grid-cols-2 gap-3 md:mt-5 md:gap-4 lg:grid-cols-4">
        {quickCards.map((c) => (
          <div
            key={c.label}
            className="flex items-center gap-3.5 rounded-2xl border border-background-200/80 bg-background-50 px-4 py-4 shadow-card transition-colors hover:border-accent-300 md:px-5"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-800">
              <i className={`${c.icon} text-xl`}></i>
            </span>
            <span className="flex flex-col">
              <span className="font-display text-xl font-black leading-none text-foreground-950 md:text-2xl">
                {c.num}
              </span>
              <span className="mt-1 text-xs text-foreground-500">
                {c.label} <span className="text-foreground-300">{c.unit}</span>
              </span>
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}